'use client';

import { c as _c } from "react/compiler-runtime";
import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { createContext, type Dispatch, type SetStateAction, useState } from 'react';
type ReviewBodyContextValue = {
  isSidebarVisible: boolean;
  setIsSidebarVisible: Dispatch<SetStateAction<boolean>>;
};
const ReviewBodyContext = createContext<ReviewBodyContextValue | null>(null);
type ReviewBodyProviderProps = React.PropsWithChildren & {
  isSidebarVisible?: boolean;
};
export function ReviewBodyProvider(props) {
  const $ = _c(5);
  const [isSidebarVisible, setIsSidebarVisible] = useState(props.isSidebarVisible || false);
  let t0;
  if ($[0] !== isSidebarVisible) {
    t0 = {
      isSidebarVisible,
      setIsSidebarVisible
    };
    $[0] = isSidebarVisible;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <ReviewBodyContext.Provider value={t0}>{props.children}</ReviewBodyContext.Provider>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export const useReviewBodyContext = () => {
  const context = useStrictContext(ReviewBodyContext);
  return context;
};